import { render, staticRenderFns } from "./tongji-folder.vue?vue&type=template&id=53dd4099&scoped=true&"
import script from "./tongji-folder.vue?vue&type=script&lang=ts&"
export * from "./tongji-folder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dd4099",
  null
  
)

export default component.exports